/**
 * Delete Icon Component
 * Reusable SVG icon for delete/remove actions
 */
import React from "react";
import PropTypes from "prop-types";

const DeleteIcon = ({
  size = 16,
  color = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M6 7h12l-1 14H7L6 7zm10-3h-4l-1-1H9L8 4H4v2h16V4h-4z"
        fill={color}
      />
    </svg>
  );
};

DeleteIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
};

export default DeleteIcon;
